'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (n) {
    return n > 0 ? '+' + n : n.toString();
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/number/numberToSignedString.js
// module id = 104
// module chunks = 0